export const removeHTMLTags = (str: string) => {
  return str?.replace(/<\/?[^>]+(>|$)/g, "");
};
